import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Config } from '../config';
import { DateUtils } from '../_commons/date-utils';
import { NumberUtils } from '../_commons/number-utils';
import { Condition } from '../_models/condition';
import { GridColor } from '../_models/grid-color';
import { GridElementDetails } from '../_models/grid-element-details';
import { GridElementMeasurementInfo } from '../_models/grid-element-measurement-info';
import { IntervalResults } from '../_models/interval-results';
import { LoadingAnalysisData } from '../_models/loading-analysis-data';
import { ReactivePowerAnalysis } from '../_models/reactive-power-analysis';
import { Series } from '../_models/series';
import { ViolationResults } from '../_models/violation-results';
import { ApplicationService } from '../_services/application/application.service';
import { ConfigurationService } from '../_services/configuration/configuration.service';
import { GMonService } from '../_services/gmon-service/gmon.service';
import { GPlanService } from '../_services/gplan-service/gplan.service';
import { GridElementService } from '../_services/grid-element/grid-element.service';
import { GuiService } from '../_services/gui-service/gui.service';
import { LaService } from '../_services/la-service/la.service';
import { MapService } from '../_services/map/map.service';
import { ReactivePowerAnalysisService } from '../_services/reactive-power-analysis-service/reactive-power-analysis.service';

@Component({
  selector: 'app-statistic-dialog-component',
  templateUrl: './statistic-dialog-component.component.html',
  styleUrls: ['./statistic-dialog-component.component.css']
})
export class StatisticDialogComponentComponent implements OnInit {

  @Input() public gridElementId: number;
  @Input() public elementType: string;

  gmonAvailable: boolean = false;
  laAvailable: boolean = false;
  lcAvailable: boolean = false;
  gplanAvailable: boolean = false;
  rpaAvailable: boolean = false;
  public gridElementIconUrl: string = "";
  gridNodeInfo: Array<any> = new Array<any>();
  gridElementName: string = "";

  isDangerGmon = false;
  isAttentionGmon = false;
  isDangerLA = false;
  isAttentionLA = false;
  isDangerRPA = false;
  isAttentionRPA = false;

  gmonDataAvailable = false;
  frequencyDataAvailable = false;
  laDataAvailable = false;
  gplanDataAvailable = false;
  rpaDataAvailable = false;

  translations: any;

  constructor(
    private spinner: NgxSpinnerService,
    public activeModal: NgbActiveModal,
    private mapService: MapService,
    private gMonService: GMonService,
    private gPlanService: GPlanService,
    private laService: LaService,
    private guiService: GuiService,
    private reactivePowerAnalysisService: ReactivePowerAnalysisService,
    public translateService: TranslateService,
    private configurationService: ConfigurationService
  ) {
    const applications: any = this.configurationService.getConfiguration().APPLICATIONS;
    this.gmonAvailable = applications.gmonAvailable;
    this.laAvailable = applications.laAvailable;
    this.lcAvailable = applications.lcAvailable;
    this.gplanAvailable = applications.gplanAvailable;
    this.rpaAvailable = applications.rpaAvailable;

    const language = localStorage.getItem("Language");
    translateService.getTranslation(language).subscribe((translations) => {
      console.log("Translations: ", translations);
      this.translations = translations;
    });
  }

  ngOnInit(): void {
    this.loadGridElementDetails();
    this.getGridNodeTabColor();
  }

  loadGridElementDetails() {
    setTimeout(() => {

    });

    this.guiService.getMeasurementInfoOfNode(this.gridElementId).subscribe(
      (gridElementMeasurementInfo: GridElementMeasurementInfo) => {
        console.log("griddetails: " + JSON.stringify(gridElementMeasurementInfo));

        //TODO missing name field into the API
        this.gridElementName = gridElementMeasurementInfo.dsoInternalIdOfNode

        if (gridElementMeasurementInfo.deviceIds) {
          let deviceIds: string = "";
          let cont: number = 0;
          gridElementMeasurementInfo.deviceIds.forEach(element => {
            cont++;
            if (cont < gridElementMeasurementInfo.deviceIds.length) {
              deviceIds = deviceIds + element + ", "
            }
            else {
              deviceIds = deviceIds + element
            }
          });
          this.gridNodeInfo.push({
            attribute: this.translations["code-string"]["device-ids"],
            value: deviceIds
          });
        }

        if (gridElementMeasurementInfo.timestampFirstSample) {
          this.gridNodeInfo.push({
            attribute: this.translations["code-string"]["timestamp-first-sample"],
            value: DateUtils.stringUTCDateToLocalDate2(gridElementMeasurementInfo.timestampFirstSample)
          });
        }

        if (gridElementMeasurementInfo.timestampLastSample) {
          this.gridNodeInfo.push({
            attribute: this.translations["code-string"]["timestamp-last-sample"],
            value: DateUtils.stringUTCDateToLocalDate2(gridElementMeasurementInfo.timestampLastSample)
          });
        }

        if (gridElementMeasurementInfo.measurandDtoList) {

          gridElementMeasurementInfo.measurandDtoList.forEach(element => {
            let measurementCategory: string = ""
            if (element.measurementCategory) {
              if (element.measurementCategory == "MEASUREMENT_VOLTAGE") {
                measurementCategory = this.translations["code-string"]["measurement-voltage"]
              }
              if (element.measurementCategory == "MEASUREMENT_CURRENT") {
                measurementCategory = this.translations["code-string"]["measurement-current"]
              }
              if (element.measurementCategory == "MEASUREMENT_FREQUENCY") {
                measurementCategory = this.translations["code-string"]["measurement-frequency"]
              }
              if (element.measurementCategory == "MEASUREMENT_ACTIVEENERGY") {
                measurementCategory = this.translations["code-string"]["measurement-activeenergy"]
              }
              if (element.measurementCategory == "MEASUREMENT_REACTIVEENERGY") {
                measurementCategory = this.translations["code-string"]["measurement-reactiveenergy"]
              }
            }

            this.gridNodeInfo.push({
              attribute: this.translations["code-string"]["measurement-category"],
              value: measurementCategory
            });

            this.gridNodeInfo.push({
              attribute: this.translations["code-string"]["coverage"],
              value: parseFloat((element.coverage * 100).toFixed(1)) + " %"
            });
          });

          // Load node icon
          this.gridElementIconUrl = this.mapService.getIconUrl(
            this.elementType,
            Condition.NORMAL
          );

        }

      },
      (error) => {
        console.error(error);

      }
    );
  }

  getGridNodeTabColor() {
    const gridColorAppsJson: string = localStorage.getItem("gridColorApps");
    if (gridColorAppsJson) {
      const gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
      let gridColor;
      for (const gc of gridColorApps) {
        if (gc.gridElementId == this.gridElementId) {
          gridColor = new GridColor(+this.gridElementId);
          gridColor.voltage = gc.voltage;
          gridColor.voltageGP = gc.voltageGP;
          gridColor.frequency = gc.frequency;
          gridColor.la = gc.la;
          gridColor.laGP = gc.laGP;
          gridColor.rpa = gc.rpa;
          break;
        }
      }
      this.setColorParameter(gridColor);
    }
  }

  private setColorParameter(gridColor: GridColor) {
    this.initDataAvailableParameters();

    if (this.gmonAvailable) {
      this.isDangerGmon = false;
      this.isAttentionGmon = false;
      // console.log('gridColor:  ' + JSON.stringify(gridColor));
      if (gridColor.voltage === Condition.ATTENTION) {
        this.isAttentionGmon = true;
      } else if (gridColor.voltage === Condition.PROBLEM) {
        this.isDangerGmon = true;
      }
      //  console.log(this.gridElementId + ', gmon-condition: ' + gridColor.gmon);
    }

    if (this.laDataAvailable) {
      this.isDangerLA = false;
      this.isAttentionLA = false;
      if (gridColor.la === Condition.ATTENTION) {
        this.isAttentionLA = true;
      } else if (gridColor.la === Condition.PROBLEM) {
        this.isDangerLA = true;
      }
    }

    if (this.rpaDataAvailable) {
      this.isDangerRPA = false;
      this.isAttentionRPA = false;
      if (gridColor.rpa === Condition.ATTENTION) {
        this.isAttentionRPA = true;
      } else if (gridColor.rpa === Condition.PROBLEM) {
        this.isDangerRPA = true;
      }
    }
  }

  private initDataAvailableParameters() {
    this.gmonDataAvailable = this.gMonService.areDataAvailable("areVoltageDataAvailable");
    this.frequencyDataAvailable = this.gMonService.areDataAvailable("areFrequencyDataAvailable");
    this.laDataAvailable = this.laService.areLADataAvailable();
    this.rpaDataAvailable = this.reactivePowerAnalysisService.areRPADataAvailable();
    this.gplanDataAvailable = this.gPlanService.areGplanDataAvailable();
  }

  /*
  loadGmonStatistics() { };
  loadLAStatistics() { };
  loadGPlanStatistics() { };
  loadRPAStatistics() { };
 */
}
